/*
 * Immutable-free helpers for working with nested plain objects — the plain-object
 * counterpart to immutable.js's `setIn`, used since the immutable.js removal
 * (issue #1654).
 */

/**
 * Immutably set a nested value on a plain object/array — a lightweight stand-in
 * for immutable.js `setIn`. Returns a new structure with `path` set to `value`,
 * cloning only the containers along the path. An empty path returns `value` (a
 * full replacement). Missing containers are created — an array when the next path
 * segment is numeric, otherwise an object. The casts are unavoidable for a generic
 * dynamic-path helper and are contained to this file.
 */
export function setIn(obj, path, value) {
  var _clone$key;
  if (path.length === 0) {
    return value;
  }
  const [key, ...rest] = path;
  const clone = Array.isArray(obj) ? [...obj] : Object.assign({}, obj);
  clone[key] = rest.length ? setIn((_clone$key = clone[key]) !== null && _clone$key !== void 0 ? _clone$key : typeof rest[0] === 'number' ? [] : {}, rest, value) : value;
  return clone;
}